module.exports = __webpack_public_path__ + "img/seo.7b5f26ab.jpg";